import React, {useState, useRef, useEffect, Fragment} from 'react';
import { ExportExcelButton, sheet, ImportExcelButton, dataCheck } from '../../lib/excel'
import { utils, writeFile } from 'xlsx'
import { keyId, sortByLabel } from '../../lib/utils'
import SchemaPriceList from '../../sanity_ecommerce/schemas/priceListItem'
import { errorAlert, successAlert, addValueForDropdown, yesNoAlert } from '../../lib/utils'
import { removeEmptyProperties } from '../../lib/utils'
import { useReplacePriceList, useReplaceInArray,  usePrepend, useDeleteInArray, useCreateReplace } from '../../hooks/mutations'
import { v4 as uuidv4, v4 } from 'uuid';
import { referenceDoc } from '../gestioneDatabase/Docs'
import { useStateContext } from '../../context/StateContext'
import Divider from '../frontend_components/Divider'
import VisDiv from '../frontend_components/VisDiv';
import { useQueryClient } from '@tanstack/react-query';
import {FiSave} from 'react-icons/fi'
import FieldDropdown from '../FieldDropdown';
import { TiDelete } from 'react-icons/ti';
import Swal from 'sweetalert2';
import TrueFalseToggle from '../TrueFalseToggle';



const PriceLists = ({data, filterByProduct=(x)=>x}) => {

    const {customer, priceLists, hideSearch, defaultCustomerProduct, customerProducts} = data
    const [filterDefault, setFilterDefault] = useState(true);
    const [filterCustomerProduct, setFilterCustomerProduct] = useState();
    const [filterPriceZero, setFilterPriceZero] = useState(false);
    const testFunction = () => {
        console.log("TEST FUNCTION", customer)
    }
  
  return (
        <div className='new-device-container'>
            <h2>LISTINI</h2>
            <VisDiv rules={[true]} style={{flex: 4, marginRight: "15px"}}>                         
                <FieldDropdown
                    sorted={true}
                    isSearchable="isSearchable"
                    initialValue={filterCustomerProduct}
                    placeHolder={"FILTRA PER PRODOTTO INTERNO"}
                    options={addValueForDropdown(customerProducts)}
                    onChange={(value) => { 
                        setFilterCustomerProduct(value)
                        console.log("jbcjwhbc", value)
                    }}
                />
            </VisDiv>
            <button style={{marginBottom:"10px"}}onClick={testFunction}>test</button>
            <h4>FILTRA LISTINI DEFAULT</h4>
            <TrueFalseToggle value={filterDefault} onClick={()=>setFilterDefault(!filterDefault)}/>
            <h4>{"FILTRA PRODOTTI PREZZO 0"}:</h4>
            <TrueFalseToggle value={filterPriceZero} onClick={()=>setFilterPriceZero(!filterPriceZero)}/>
            {!Array.isArray(priceLists) ? [] : priceLists?.filter?.((x)=>{
                if(filterDefault) return x?.default
                return x
            })
            ?.map?.((priceList, index)=>{
            //const data = {customerProducts, customer, priceList, setCustomer}
            return <ListinoPin filterByProduct={filterByProduct} key={priceList?._id} data = {{...data, filterCustomerProduct, priceList, filterPriceZero, hideSearch, defaultCustomerProduct}}/>})}       
        </div>
  )
}

export default PriceLists

//========================================================================================================================

/**
 * 
 * @param {*} param0 inside a customer?.priceList array map?.(priceList, index). priceList, index, customerProducts: array of _type customerProduct files }
 * @returns a box with the name of the priceList and import/export excel buttons
 */

export const ListinoPin = ({data, filterByProduct}) => {


 const {customerProducts, filterCustomerProduct,  customer, priceList, setCustomer, clients, filterPriceZero, hideSearch, defaultCustomerProduct} = data
 const {
    excelData,
    setExcelData,
} = useStateContext();

const expandedFilteredClients = (clients) => priceList?.clients?.map?.((item)=>{
    const foundClient = !Array.isArray(clients) ? undefined : clients?.find?.((x)=>x?._id == item?._ref)
    return foundClient
})

const [searchValue, setSearchValue] = useState("");
const searchRef = useRef();
const [viewProducts, setViewProducts] = useState(false);
const [viewAssignClients, setViewAssignClients] = useState(false);
const [clientsToAssign, setClientsToAssign] = useState(expandedFilteredClients(clients));
const queryClient = useQueryClient()

const {mutate: updateDocument} = useCreateReplace({
    onMutate: async (newDoc) => {

        await queryClient.cancelQueries({ queryKey: ['priceLists'] })
        const previousData = queryClient.getQueryData(['priceLists'] )
   
        //const doc = newDoc?.doc
        
        queryClient.setQueryData(['priceLists'], (old) =>{ 
            const doc = newDoc?.doc
            const oldDoc = old?.length < 1 ? [] : old
            const newData = [...oldDoc?.filter?.(x=>x?._id!== doc._id), doc]          

            return newData
        })
        return {previousData }
    },
    onError:(err)=>{
        console.log("Document Not Updated, error", err?.message);
        errorAlert("Errore: il documento non é stato aggiornato")
    }})
const {mutate: replacePriceList} = useReplacePriceList({
    /*     onMutate: async (newDoc) => {
    
            await queryClient.cancelQueries({ queryKey: ['registers', site] })
            const previousRegisters = queryClient.getQueryData(['registers', site])
            //const doc = newDoc?.doc
    
            queryClient.setQueryData(['registers', site], (old) =>{ 
                
                //const newData = [...oldData?.filter?.(x=>x?._id!==updatedRegister(doc)?._id), updatedRegister(doc)]
                //setRegisters(newData)
                //setRegister(updatedRegister(doc))
                //setCurrentDevice(doc)
                //newDoc?.customFn && newDoc?.customFn()
                const newData = offlineFn(newDoc, old)
                return newData
            })
            setLoading(false)
            return { previousRegisters, device, register}
        }, */
        onError: (err, newDoc, context) => {
            errorAlert(errorAlert("Errore: il listino non é stato aggiornato"))
    /*         queryClient.setQueryData(['registers', site], context?.previousRegisters)
            setRegisters(context.previousRegisters)
            setRegister(context.register)
            updateDevices(devices, setDevices, device, context?.device) */
            console.error('Oh no, the update failed: ', err?.message)}
        })

 const onClick = () => {
    //console.log("CLICKED PIN", priceList, customer)
    //console.log("adding to doc", addingToDoc)
   // console.log("dati listino", dataFromProductsImport)
    
    const doc = addingToDoc

    //console.log("BEGIN UPDATE")
/*     const queryDoc = {
        id: customer?._id, 
        key: findKey(),
        doc,
    }   */

    //const nonExistantId = "7fe95b66-1c6a-8190-5521-998832186769"
    //const findIt = dataFromProductsImport?.find?.((x)=>x?.customerProduct?._ref == nonExistantId)
    //console.log("non existant id:", findIt)

/*     replacePriceList(queryDoc,{
        onSuccess:()=>{
            console.log("Document Updated Successfully");
            const newCustomerDoc = {
                ...customer,
                priceLists: [...customer?.priceLists?.filter?.((x)=>x?._key !== doc?._key), doc]
            }
            setCustomer(newCustomerDoc)
    }})  */ 
 }

 const dataFromProductsImport = !excelData ? [] : excelData?.filter?.(x=>!x?.cartello)?.map?.((item)=>({
    _id: uuidv4(),
    _type: "priceListItem",
    label: item?.name,
    price: item?.listPrice,
    priceListSource: item?.priceListSource,
    _key: item?._key ? item?._key : keyId(),
    customerProduct: referenceDoc(item?._id),
}))
const addingToDoc = {
    ...priceList,
    products: [...priceList?.products, ...dataFromProductsImport ]
}

const listProducts = priceList?.products

const productsData = customerProducts?.map?.((product)=>{

    const listProduct = !Array.isArray(listProducts) ? undefined : listProducts?.find?.((x)=>product?._id == x?.customerProduct?._ref )
    return({
        label: listProduct?.label ? listProduct?.label : product?.label,
        customerProductId: product?._id,
        _key: listProduct?._key ? listProduct?._key : keyId(),
        _type: "priceListItem",
        price: listProduct?.price,
        priceListSource: listProduct?.priceListSource,   
  })})
  const mainSheet = sheet(productsData ,"PRODOTTI")
  

const sheets = [mainSheet]

const importedData = (excelData) => {
    //console.log("IMPORT EXCEL", data)
    const workedData = excelData?.map?.((item)=>({
        _type: item?._type,
        _id: uuidv4(),
        label: item?.label,
        price: item?.price,
        priceListSource: item?.priceListSource,
        _key: item?._key ? item?._key : keyId(),
        customerProduct: {_ref: item?.customerProductId, _type:"reference", _key: item?.customerProduct?._key ? item?.customerProduct?._key : keyId()},
    }))



    const dataCheckDoc = {excelData: workedData, type:"priceListItem", schema: SchemaPriceList}
    const dataConforms = dataCheck(dataCheckDoc)
    console.log("CHECK PASSED",dataConforms)

    const doc = {
        ...priceList,
        products: workedData
    }

    
    if(dataConforms){
        console.log("BEGIN UPDATE")
        const queryDoc = {
            id: customer?._id, 
            //key: findKey(),
            doc,
        }  
    console.log("QUERY DOC:", queryDoc)
    
    replacePriceList(queryDoc,{
        onSuccess:()=>{
            console.log("Document Updated Successfully");
            const newCustomerDoc = {
                ...customer,
                //priceLists: [...customer?.priceLists?.filter?.((x)=>x?._key !== doc?._key), doc]
            }
            setCustomer(newCustomerDoc)
    }})  
    }
}

const filterByCustomerProduct = (x) => {
  if(filterCustomerProduct) return x?.customerProduct?._ref == filterCustomerProduct?._id
  return x
}


const searchFilter = (x) =>{
    // search-box
   const search =  x?.label?.toLowerCase()?.indexOf(searchValue.toLowerCase()) >= 0
   if(filterPriceZero) return search && (x?.price == 0 || !x?.price)
   return search 
}
   //search-box
   const onSearchClick = (e) => {
    e.stopPropagation()
  };
  const onSearch = (e) => {
    setSearchValue(e.target.value);
  };
  const duplicate = async () => {
    //const inputValue = "";
    const { value: listName } = await Swal.fire({
        title: "Nome Listino",
        input: "text",
        //inputLabel: "Nome Offerta",
        //inputValue,
        showCancelButton: true,
        inputValidator: (value) => {
            if (!value) {
            return "Inserire un nome per questo listino";
            }
        }
        });
        if (listName) {
        const doc = {
            ...priceList,
            label: listName,
            default: false,
            _id: uuidv4(),
            _key: keyId(),

        }
        console.log("duplicate", doc)
        updateDocument({doc})
        }
    }
    const testFunction = () => {
        console.log("TEST PLIST PIN", {priceList, customer})
    }
    const saveAssignClients = () => {
        const references = clientsToAssign?.map?.((item)=>({_type: "reference", _key:keyId(), _ref: item?._id}))
        const doc = {...priceList, clients: references}
        updateDocument({doc})
        setViewAssignClients(false)
        //console.log("SAVE ASSIGN CLIENTS")
    }
return (
<div style={{borderRadius:"10px",border:"2px solid grey", padding:"10px", marginBottom:"5px"}}>
    
    <div onClick={onClick} style={{padding:"10px"}}>
        <div style={{display:"flex", justifyContent:"space-evenly", alignItems:"center"}}>
            <h3>
            {priceList?.label}
            </h3>
            <button className="pdf-button" style={{marginTop: 0}} onClick={()=>setViewProducts(!viewProducts)}>VEDI PRODOTTI</button>
            <VisDiv>
                <button onClick={duplicate} className="pdf-button"  style={{marginTop: 0}}>
                    {"DUPLICA LISTINO"}
                </button>
            </VisDiv>
            <VisDiv rules={[!priceList?.default]}>
                <button onClick={()=>{setViewAssignClients(!viewAssignClients); setClientsToAssign(expandedFilteredClients(clients)) }} className="pdf-button"  style={{marginTop: 0}}>
                    {"ASSEGNA CLIENTI"}
                </button>
            </VisDiv>
            <VisDiv onClick={testFunction} rules={[true]}><button>Test List Pin</button></VisDiv>
        {/*     <ExportExcelButton sheets={sheets} title={`PRODOTTI LISTINI`} /> 
            <ImportExcelButton returnedData = {importedData} /> */}
        
        </div>
     
        <div style={{marginBottom:"10px"}}>
        <VisDiv rules={[viewAssignClients]}>
            <Divider bottom={"10px"}/>
            <h3>ASSEGNA CLIENTI</h3>
            <FieldDropdown
                isMulti={true}
                isSearchable="isSearchable"
                initialValue={addValueForDropdown(clientsToAssign)}
                placeHolder={"ASSEGNA CLIENTI"}
                options={addValueForDropdown(clients)?.sort(sortByLabel)}
                onChange={(value) => {
                    setClientsToAssign(value)
                }
                }
            />
            <VisDiv>
                <button onClick={saveAssignClients} className="pdf-button"  style={{marginTop: 0, backgroundColor:"green"}}>
                    {"SALVA"}
                </button>
            </VisDiv>
            
            <VisDiv style={{marginTop:"10px"}} rules={[clientsToAssign?.length > 1]}>
                <h4>CLIENTI ASSEGNATI</h4>
                {
                    clientsToAssign?.map?.((item)=>{
                        
                        return (
                            <div style={{padding:"2px"}} key={item?._id}>
                                {item?.label}
                            </div>
                            )
                    })
                }
            </VisDiv>
        
        </VisDiv>
        <Divider/>
        </div>
        <VisDiv rules={[viewProducts]}>
            <VisDiv rules={[!hideSearch || !Array.isArray(priceList?.products) ? false : priceList?.products?.filter?.(filterByProduct)?.length < 1]}>
                <AddPriceListProduct defaultCustomerProduct={defaultCustomerProduct} priceList={priceList} customerProducts={customerProducts}/>
            </VisDiv>
            <VisDiv rules={[!hideSearch]}>
                <h4>CERCA PRODOTTO:</h4>
                <div className="search-box" style={{backgroundColor:"white", fontSize:"12px"}}>
                    <input onClick={(e)=>onSearchClick(e)} style={{fontSize:"18px"}} onChange={onSearch} value={searchValue} ref={searchRef} />
                </div>
            </VisDiv>

    
            {priceList?.products
                ?.filter?.(filterByCustomerProduct)
                ?.filter?.(searchFilter)
                ?.filter?.(filterByProduct)
              
                ?.sort(sortByLabel)
                ?.map?.((item, index)=>{
                
                return (
                    <div key={item?._key}>
                        <PriceListProduct product={item} index={index} priceList={priceList}/>
                    </div>
                )
            })}
        </VisDiv>

    </div>
{/*    <div style={{display:"flex"}}>
     <button className='red-button' onClick={()=>deleteDevice({documentId: item?._id })}>ELIMINA</button>
     <a className='red-button' style={{marginLeft:"5px", backgroundColor:"blue"}} target="_blank" href={`http://localhost:3333/desk/nonConformity;${item?._id}`} >MODIFICA</a>
   </div>
 */}

 </div>
)}

//===================================================================



export const PriceListProduct = ({product, index, priceList}) => {
        const rowColour = index % 2 ? "white":"#e6e6e6"
        const queryClient = useQueryClient()
        const [priceProduct, setPriceProduct] = useState(product)

        
        const {mutate: updatePrice} = useReplaceInArray({
                onMutate: async (newDoc) => {          
                    await queryClient.cancelQueries({ queryKey: ['priceLists'] })
                    const previousPriceLists = queryClient.getQueryData(['priceLists'])   
                    queryClient.setQueryData(['priceLists'], (old) =>{ 
                        const oldDoc = old?.length < 1 ? [] : old
                        const newData = [...oldDoc?.filter?.(x=>x?._id!==newDoc?.id), {...priceList, products:[...!Array.isArray(priceList?.products) ? [] : priceList?.products?.filter?.((x)=>x?._key !== newDoc?.key), newDoc?.doc]}]

                        return newData
                    })
                    
                    return { previousPriceLists }
                }, 
                onError: (err, newDoc, context) => {
                    errorAlert("Errore: il prezzo non é stato aggiornato")
            /*         queryClient.setQueryData(['registers', site], context?.previousRegisters)
                    setRegisters(context.previousRegisters)
                    setRegister(context.register)
                    updateDevices(devices, setDevices, device, context?.device) */
                    console.error('Oh no, the update failed: ', err?.message)}
                })

                const {mutate: deletePriceLine} = useDeleteInArray({
                    onMutate: async (newDoc) => {          
                        await queryClient.cancelQueries({ queryKey: ['priceLists'] })
                        const previousPriceLists = queryClient.getQueryData(['priceLists'])   
                        queryClient.setQueryData(['priceLists'], (old) =>{ 
                            const oldDoc = old?.length < 1 ? [] : old
                            const newData = [...oldDoc?.filter?.(x=>x?._id!==newDoc?.id), {...priceList, products:[...!Array.isArray(priceList?.products) ? [] : priceList?.products?.filter?.((x)=>x?._key !== newDoc?.key)]}]
                            return newData
                        })
                        
                        return { previousPriceLists }
                    }, 
                    onError: (err, newDoc, context) => {
                        errorAlert("Errore: il prezzo non é stato aggiornato")
                /*         queryClient.setQueryData(['registers', site], context?.previousRegisters)
                        setRegisters(context.previousRegisters)
                        setRegister(context.register)
                        updateDevices(devices, setDevices, device, context?.device) */
                        console.error('Oh no, the update failed: ', err?.message)}
                    })

                const deleteLine = () =>{
                    console.log("DELETE LINE")
                    const queryDoc = {
                        id: priceList?._id, 
                        arrayName: "products",
                        key: priceProduct?._key,
                    }
                    yesNoAlert( ()=>deletePriceLine(queryDoc), `VUOI ELIMINARE ${priceProduct?.label}?`)
                   
                }

                const save = () => {
                    const queryDoc = {
                        id: priceList?._id, 
                        arrayName: "products",
                        key: priceProduct?._key,
                        doc:  {...priceProduct, price: Number(priceProduct?.price)},
                    }
                        updatePrice(queryDoc)
                  
                    //console.log("SAVE", priceProduct, priceList, queryDoc)

                }
    return (
    <div style={{backgroundColor:rowColour, padding:"10px", display:"flex", justifyContent:"space-evenly", alignItems:"center"}}>
        <VisDiv style={{marginRight:"10px"}}>
            <button
                type="button"
                className="remove-item"
                onClick={() => deleteLine()}
                >
                <TiDelete />
            </button>
        </VisDiv>
        <div style={{flex: 2}}><input onBlur={save} className="emptyInputText" type="text" value={priceProduct?.priceListSource} placeHolder="INSERISCI NOME LISTINO" onChange={(e) => {setPriceProduct({...priceProduct, priceListSource:e.target.value});}}/></div>
        <div style={{flex: 4}}><input onBlur={save} className="emptyInputText" type="text" value={priceProduct?.label} placeHolder="INSERISCI TITOLO" onChange={(e) => {setPriceProduct({...priceProduct, label:e.target.value});}}/></div>
        <div style={{flex: 1, display:"flex", alignItems:"center"}}>{"€"}<input onBlur={save} className="emptyInputText" type="number" value={priceProduct?.price} onChange={(e) => {setPriceProduct({...priceProduct, price:e.target.value});}}/></div>

    </div>
    )
}

//==========================


export const AddPriceListProduct = ({defaultCustomerProduct, priceList, customerProducts, setNewDocument = ()=>{}}) => {

    const initialCustomerProduct = !defaultCustomerProduct ? {_key: keyId(), _type: "reference", _ref: ""}:{_key: keyId(), _type: "reference", _ref: defaultCustomerProduct?._id}
    const initialLabel = !defaultCustomerProduct ? "" : defaultCustomerProduct?.label

    const emptyDoc = () => ({
        _type: "priceListItem",
       _id: uuidv4(),
       _key: keyId(),
       label: initialLabel,
       priceListSource: "",
       price: Number(0),
       customerProduct: initialCustomerProduct
   })


    const [customerProduct, setCustomerProduct] = useState()

    const [priceProduct, setPriceProduct] = useState(emptyDoc())
    const queryClient = useQueryClient()
        const {mutate: addPriceLine} = usePrepend({
                onMutate: async (newDoc) => {          
                    await queryClient.cancelQueries({ queryKey: ['priceLists'] })
                    const previousPriceLists = queryClient.getQueryData(['priceLists'])   
                    queryClient.setQueryData(['priceLists'], (old) =>{ 
                        const oldDoc = old?.length < 1 ? [] : old
                        const newData = [...oldDoc?.filter?.(x=>x?._id!==newDoc?.id), {...priceList, products:[...!Array.isArray(priceList?.products) ? [] : priceList?.products?.filter?.((x)=>x?._key !== newDoc?.key), newDoc?.doc]}]

                        return newData
                    })
                    
                    return { previousPriceLists }
                }, 
                onError: (err, newDoc, context) => {
                    errorAlert("Errore: il prezzo non é stato aggiornato")
            /*         queryClient.setQueryData(['registers', site], context?.previousRegisters)
                    setRegisters(context.previousRegisters)
                    setRegister(context.register)
                    updateDevices(devices, setDevices, device, context?.device) */
                    console.error('Oh no, the update failed: ', err?.message)}
                })

            const save = () => {
                const queryDoc = {
                    id: priceList?._id, 
                    arrayName: "products",
                    key: priceProduct?._key,
                    doc: {...priceProduct, price: Number(priceProduct?.price)},
                }
            
                addPriceLine(queryDoc,{
                    onSuccess:()=>{
                        setPriceProduct(emptyDoc())
                        setCustomerProduct({}) 
                    }
                })    
                console.log("SAVE", priceProduct, priceList, queryDoc)
                setNewDocument(queryDoc?.doc)

            }
            const testFunction = () => {
                console.log("PRICE LIST", priceList)
            }
            const filteredExistingCustomerProducts = !Array.isArray(customerProducts) ? [] : customerProducts?.filter?.((item)=> !priceList?.products?.some?.((x)=>item?._id == x?.customerProduct?._ref))
return (
<>
<p onClick={testFunction}>test</p>
<h4>AGGIUNGI PRODOTTO:</h4>
<div style={{backgroundColor:"white", padding:"10px", display:"flex", justifyContent:"space-evenly", alignItems:"center"}}>

    <div style={{flex: 2, marginRight: "10px"}}><input placeholder='NOME LISTINO' className='text-input' type="text" value={priceProduct?.priceListSource} onChange={(e) => {setPriceProduct({...priceProduct, priceListSource:e.target.value});}}/></div>
    <div style={{flex: 4, marginRight: "10px"}}><input placeholder='NOME PRODOTTO' className="text-input" type="text" value={priceProduct?.label} onChange={(e) => {setPriceProduct({...priceProduct, label:e.target.value});}}/></div>
    <VisDiv rules={[!defaultCustomerProduct]} style={{flex: 4, marginRight: "15px"}}>                         
        <FieldDropdown
            sorted={true}
            isSearchable="isSearchable"
            initialValue={customerProduct}
            placeHolder={"ASSEGNA PRODOTTO INTERNO"}
            options={addValueForDropdown(filteredExistingCustomerProducts)}
            onChange={(value) => { 
                setCustomerProduct(value)
                setPriceProduct({
                    ...priceProduct,
                    customerProduct: {
                        ...priceProduct?.customerProduct,
                        _ref: value?._id
                    }
                })
            }}
        />
    </VisDiv>
    <div style={{flex: 1, display:"flex", alignItems:"center"}}>{`€ `}<input placeholder={0} className="text-input" inputMode="numeric" type="number" value={priceProduct?.price} onChange={(e) => {setPriceProduct({...priceProduct, price:e.target.value});}}/></div>
    <VisDiv style={{color:"darkBlue", cursor:"pointer", marginLeft:"10px"}} >
        <VisDiv>
            <button type='button' className='round-back-button' style={{backgroundColor:"green"}} onClick={save}>
                <FiSave            
                size={15}
                color={"white"}/>
            </button>
        </VisDiv>
    </VisDiv>
</div>
<Divider bottom={"15px"}/>
</>
)
}